import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import AssetFieldsConfig from "components/core/asset/fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Marquee Cards",
  fields: {
    ...ThemeConfig,
    cards: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Cards",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          cardAsset: { type: FIELD_TYPES.GALLERY, label: "Card Asset" },
          cardLogoAsset: { type: FIELD_TYPES.GALLERY, label: "Card Logo Asset" },
          titleText: {
            type: FIELD_TYPES.TEXT,
            label: "Title"
          },
          useCases: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Use cases",
            nestedConfig: {
              type: FIELD_TYPES.NESTED,
              fields: {
                useCase: { type: FIELD_TYPES.TEXT, label: "Use cases" }
              }
            }
          },
          productType: { type: FIELD_TYPES.PRODUCTS, label: "Product type" }
        }
      }
    }
  }
};
